export default __webpack_public_path__ + "static/media/tour2.21a47e68.webp";